<template>
  <v-container fluid>
    <section class="access_devices__modal" >
      <v-card style="background-color:transparent">
        <v-card-text>
          <!-- Tabla General -->
          <div class="table_card">
            <div class="table_card__head">
              <v-layout row wrap fill-height>
                <v-flex xs12>
                  <p class="table_card__head--title">Tabla de Cobros a Cargar</p>
                </v-flex>
              </v-layout>
            </div>
            <v-data-table :headers="tableOptions.headers_table" :items="paymentsLoaded" :search="tableOptions.search"
              :pagination.sync="tableOptions.pagination">
              <template v-slot:items="props">
                <tr>
                  <td class="text-center">{{ props.item.payment_reference }}</td>
                  <td class="text-center">{{ props.item.document_id }}</td>
                  <td class="text-center">{{ formatDate(props.item.limit_date) }}</td>
                  <td class="text-center">{{ props.item.concept }}</td>
                  <td class="text-justify">{{ formatAmount(props.item.amount) }}</td>
                  <td class="text-center">{{ props.item.location }}</td>
                  <td class="text-center">{{ props.item.service }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <v-layout justify-center class="mt-2">
            <v-btn color="grey" @click="onCancel" class="rounded-button">
              Cancelar
            </v-btn>
            <v-btn color="primary" @click="onLoad" class="rounded-button" elevation="2">
              Cargar
            </v-btn>
          </v-layout>

        </v-card-text>
      </v-card>
    </section>
  </v-container>
</template>

<script>
export default {
  props: {
    paymentsLoaded: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      tableOptions: {
        headers_table: [
          { text: 'Referencia de Pago', value: 'payment_reference' },
          { text: 'ID Documento', value: 'document_id' },
          { text: 'Fecha Límite', value: 'limit_date' },
          { text: 'Concepto', value: 'concept' },
          { text: 'Monto', value: 'amount' },
          { text: 'Locación', value: 'location' },
          { text: 'Servicio', value: 'service' },
        ],
        search: '',
        pagination: { page: 1, rowsPerPage: 10 },
      },
    };
  },
  methods: {
    onCancel() {
      this.$emit('cancelAction');
    },
    onLoad() {
      // Lógica para el botón de cargar
      this.$emit('loadData', this.paymentsLoaded);
    },
    formatDate(date) {
      // Verifica si la fecha es null o undefined
      if (date === null || date === undefined) {
        return ''; // o puedes devolver null, dependiendo de lo que necesites
      }

      // Formatear solo el mes como texto
      return new Date(date).toLocaleDateString('es-CO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    formatAmount(amount) {
      // Formatear el monto con símbolo de pesos
      return `$${amount.toLocaleString()}`; // Suponiendo que amount es un número
    },
  },
};
</script>




<style scoped>

.table_card {
  background-color: rgba(255, 255, 255, 0.349);
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table_card__head {
  border-bottom: 1px solid #e9e3e32c;
  padding-bottom: 8px;
  margin-bottom: 16px;
}

.table_card__head--title {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.text-center {
  text-align: center;
  align-items: center;
  padding-left: 12px;
}

.text-justify {
  text-align: right;
  align-items: center;
  padding-left: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/users/payment_status/Modals/NewPaymentsView.vue